var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"z7-item"},[_c('div',{staticClass:"z-top-left"},[_c('img',{staticClass:"jisuan",attrs:{"src":_vm.imgUrl,"alt":""}})]),_c('div',{staticClass:"z-top-right"},[_c('span',{},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"right-wdsl"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }